import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { CreatedBy } from "../PublicViewRender";
import {
  getBase64ImageFromUrl,
  getGoogleImageUrl,
} from "../../../../../utils/helpers";
import { ActiveImg } from "../ConcepMoodBoard/ImgGrid";

const FormImagesLayout = ({
  heading,
  images = [],
  createdBy,
  creationDate,
  isPdf,
  isVideo,
}) => {
  return (
    <div className="w-full h-full flex flex-col relative">
      <div
        className={`bg-[#06565E] playfair text-[#EABC9D] text-xl sm:text-3xl text-center font-bold italic py-1 sm:py-2 `}
      >
        <>
          {isPdf ? (
            <span className="text-center w-full relative bottom-3.5">
              {heading}
            </span>
          ) : (
            <>{heading}</>
          )}
        </>
      </div>
      <div className=" min-h-0 overflow-hidden grow  ">
        <ImageLayout
          isVideo={isVideo}
          isPdf={isPdf}
          allImages={images.map((i) => getGoogleImageUrl(i))}
        />
      </div>

      <div
        className={`absolute ${isPdf ? "-bottom-1 -left-1" : "-bottom-2 -left-3"}  w-fit text-nowrap `}
      >
        <CreatedBy username={createdBy} date={creationDate} isPdf={isPdf} />
      </div>
    </div>
  );
};

export const ImageLayout = ({
  allImages,
  isPdf,
  isVideo,
  isSite,
  siteProps,
}) => {
  const [images, setImages] = useState(allImages);

  useEffect(() => {
    async function getBaseImgs() {
      const base64Imgs = await Promise.all(
        allImages.map((i) => getBase64ImageFromUrl(i)),
      );
      setImages(base64Imgs);
    }
    if (isPdf && allImages && allImages.length > 0) {
      getBaseImgs();
    } else {
      setImages(allImages);
    }
  }, [allImages, isPdf]);

  // useEffect(()=> {
  //   async function getImages (){
  // console.log("GOOGLE IMGS", allImages, images)

  // // const imgs= await Promise.all(allImages.map(i=> getGoogleImageUrl(i)));
  // console.log("BASE 64 IMGS", imgs)
  // setImages(imgs)
  //   }
  //   getImages()
  // },[allImages])
  console.log("IMAGES GC", images, isVideo);
  if (isVideo) {
    if (isPdf) {
      return (
        <div className="mt-2 inter">
          <a
            href={images?.[0]}
            className="text-blue-500 underline hover:text-blue-600"
          >
            {images?.[0]}
          </a>
        </div>
      );
    }
    return (
      <div
        className={classNames("overflow-hidden bg-white w-full h-full")}
        style={{}}
      >
        <video className="w-full h-full" controls>
          <source src={images?.[0]} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }
  if (images.length == 1) {
    return (
      <div className=" w-full h-full ">
        <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
      </div>
    );
  }
  if (images.length == 2) {
    return (
      <div className="grid grid-cols-2 gap-0.5 w-full h-full ">
        <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
        <ImgDiv url={images?.[1]} isSite={isSite} siteProps={siteProps} />
      </div>
    );
  }
  if (images.length == 3) {
    return (
      <div className="grid grid-cols-2 gap-0.5 w-full h-full ">
        <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
        <div className="grid grid-cols-1 gap-0.5  w-full h-full">
          <ImgDiv url={images?.[1]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[2]} isSite={isSite} siteProps={siteProps} />
        </div>
      </div>
    );
  }
  if (images.length == 4) {
    return (
      <div className="grid grid-cols-2 gap-0.5 w-full h-full ">
        <div className="grid grid-cols-1 gap-0.5 ">
          <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[3]} isSite={isSite} siteProps={siteProps} />
        </div>

        <div className="grid grid-cols-1 gap-0.5 ">
          <ImgDiv url={images?.[1]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[2]} isSite={isSite} siteProps={siteProps} />
        </div>
      </div>
    );
  }
  if (images.length == 5) {
    return (
      <div className=" grid grid-rows-2 gap-0.5 h-full w-full ">
        <div className="grid grid-cols-2 gap-0.5  ">
          <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[1]} isSite={isSite} siteProps={siteProps} />
        </div>

        <div className="grid grid-cols-3 gap-0.5  ">
          <ImgDiv url={images?.[2]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[3]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[4]} isSite={isSite} siteProps={siteProps} />
        </div>
      </div>
    );
  }
  if (images.length == 6) {
    return (
      <div className=" grid grid-rows-2 gap-0.5 h-full w-full ">
        <div className="grid grid-cols-3 gap-0.5  ">
          <ImgDiv url={images?.[0]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[1]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[2]} isSite={isSite} siteProps={siteProps} />
        </div>

        <div className="grid grid-cols-3 gap-0.5  ">
          <ImgDiv url={images?.[3]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[4]} isSite={isSite} siteProps={siteProps} />
          <ImgDiv url={images?.[5]} isSite={isSite} siteProps={siteProps} />
        </div>
      </div>
    );
  }
  return (
    <div className=" grid grid-cols-3 gap-0.5 h-full w-full ">
      <div className="grid grid-rows-5 gap-0.5  ">
        <ImgDiv
          url={images?.[0]}
          className=" row-span-3"
          isSite={isSite}
          siteProps={siteProps}
        />
        <ImgDiv
          url={images?.[1]}
          className=" row-span-2"
          isSite={isSite}
          siteProps={siteProps}
        />
        {/* <ImgDiv url={images?.[2]} /> */}
      </div>

      <div className="grid grid-rows-3 gap-0.5  ">
        <ImgDiv url={images?.[2]} isSite={isSite} siteProps={siteProps} />
        <ImgDiv url={images?.[3]} isSite={isSite} siteProps={siteProps} />
        <ImgDiv url={images?.[4]} isSite={isSite} siteProps={siteProps} />
      </div>
      <div className="grid grid-rows-5 gap-0.5  ">
        <ImgDiv
          url={images?.[5]}
          className=" row-span-2"
          isSite={isSite}
          siteProps={siteProps}
        />
        <ImgDiv
          url={images?.[6]}
          className=" row-span-3"
          isSite={isSite}
          siteProps={siteProps}
        />
        {/* <ImgDiv url={images?.[2]} /> */}
      </div>
    </div>
  );
};

const ImgDiv = ({ url, className = "", isSite = false, siteProps = {} }) => {
  if (isSite) {
    return (
      <div className="w-full h-full overflow-hidden bg-gray-100">
        <ActiveImg src={url} {...siteProps} />
      </div>
    );
  }
  return (
    <div
      style={{
        backgroundImage: `url(${url})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className={classNames(
        " overflow-hidden bg-red-100 w-full h-full",
        className,
      )}
    >
      {/* <img src="https://drive.google.com/thumbnail?id=1-1XhqVm-KN7kSIeSJJsqst6dd76XRr4z&sz=w1000" className="w-96 h-80"/> */}

      {/* <iframe src={url}/> */}
      {/* <img src='https://drive.google.com/file/d/1G-I6sthxekd2qxUGSKs4Xb4JkNjiNlb5/view?usp=sharing'/> */}
    </div>
  );
};

export default FormImagesLayout;
